import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';
import withRemoveDialog from '~/hoc/withRemoveDialog';
import Button from '~/components/CustomButton/CustomButton.jsx';
import SwitchWidget from '../../SwitchWidget.js';
import TableWidget from '../../TableWidget.js';
import WorkHoursRulesForm from './WorkHoursRulesForm.js';

//elements
import { NumberInput } from '~/elements/Input.js';
import LoadingSpinner from '~/elements/LoadingSpinner';

//assets
import CloseModalIcon from '~/assets/img/CloseApproveModalIcon.svg';


class AverageWorkHoursRules extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            workPlanSettings: {
                allow_work_hours_settings: false,
                allow_union_approval: false,
                allow_strict_mode: true,
                allow_resource_planner: false,
                allow_optional_roster_shift_override: false,
                union_emails: [],
                lockInPeriodForUnionApproval: 28,
                lockInPeriodForPublish: 14,
                lockInPeriodEditPublishedShift: 3,
            },
            workHoursRulesBasedOnDepartments: [],
            isEdit: false,
            editData: {},
            showEmailModal: false,
        }
    }

    updateData = async (data) => {
        const { commonStore, t, clientStore } = this.props;
        if (data.hasError)
            return commonStore.addNotification(t(data.errors[0].error), null, 'warning');

        this.setState({ loading: true }, async () => {
            try {
                if (this.state?.editData?.id)
                    await clientStore.editWorkHoursRule(this.state.editData.id, data);
                else
                    await clientStore.saveWorkHoursRule(data);
                commonStore.addNotification(t('Work hours rule saved successfully'), null, 'success');
                this.loadWorkHoursRules();
            } catch (err) {
                console.error(err)
                this.setState({ loading: false })
            }
        });
    }


    componentDidMount() {
        this.setState({ loading: true }, this.loadData);
    }

    loadData = async () => {
        const { currentEntity } = this.props.clientStore;
        const { workPlanSettings } = this.state;
        const { allow_work_hours_settings, allow_union_approval, allow_strict_mode, allow_resource_planner, allow_optional_roster_shift_override,
            lockInPeriodForUnionApproval, lockInPeriodForPublish, lockInPeriodEditPublishedShift } = workPlanSettings;
        if (currentEntity.client.data && currentEntity.client.data.basicRules) {
            const { workPlanSettings: _workPlanSettings } = Object.assign({}, currentEntity.client.data.basicRules);
            workPlanSettings.allow_work_hours_settings = _workPlanSettings?.allow_work_hours_settings !== undefined ? _workPlanSettings?.allow_work_hours_settings : allow_work_hours_settings;
            workPlanSettings.allow_union_approval = _workPlanSettings?.allow_union_approval !== undefined ? _workPlanSettings?.allow_union_approval : allow_union_approval;
            workPlanSettings.allow_strict_mode = _workPlanSettings?.allow_strict_mode !== undefined ? _workPlanSettings?.allow_strict_mode : allow_strict_mode;
            workPlanSettings.allow_resource_planner = _workPlanSettings?.allow_resource_planner !== undefined ? _workPlanSettings?.allow_resource_planner : allow_resource_planner;
            workPlanSettings.allow_optional_roster_shift_override = _workPlanSettings?.allow_optional_roster_shift_override !== undefined ? _workPlanSettings?.allow_optional_roster_shift_override : allow_optional_roster_shift_override;
            workPlanSettings.union_emails = _workPlanSettings?.union_emails || [];
            workPlanSettings.lockInPeriodForUnionApproval = _workPlanSettings?.lockInPeriodForUnionApproval || lockInPeriodForUnionApproval;
            workPlanSettings.lockInPeriodForPublish = _workPlanSettings?.lockInPeriodForPublish || lockInPeriodForPublish;
            workPlanSettings.lockInPeriodEditPublishedShift = _workPlanSettings?.lockInPeriodEditPublishedShift || lockInPeriodEditPublishedShift;
            this.setState({ loading: true, workPlanSettings }, this.loadWorkHoursRules)
        }
    }

    loadWorkHoursRules = async () => {
        const { clientStore, commonStore, t } = this.props;
        try {
            const result = await clientStore.getWorkHoursRule();
            this.setState({
                workHoursRulesBasedOnDepartments: result.workHoursRule,
                loading: false,
                isEdit: false,
                editData: {},
            });
        } catch (err) {
            console.error(err);
            commonStore.addNotification(t('Something went wrong!'), null, 'error');
            this.setState({ loading: false });
        }
    }

    deleteRule = async (id) => {
        const { clientStore, commonStore, t } = this.props;
        try {
            await clientStore.deleteWorkHoursRule(id, false);
            commonStore.addNotification(t('Work hours rule deleted successfully'), null, 'success');
            this.loadWorkHoursRules()
        } catch (err) {
            console.error(err);
            this.setState({ loading: false });
        }
    }

    handleDataDelete = (index) => {
        const data = this.state.workHoursRulesBasedOnDepartments[index];
        const id = data?.id;

        if (!id) return;
        this.setState({ loading: true }, () => {
            return this.props.handleDelete(id, (id) => {
                return this.deleteRule(id);
            }, null, () => this.setState({ loading: false }));
        })
    }

    editRule = (index) => {
        const { allow_work_hours_settings } = this.state.workPlanSettings;
        if (!allow_work_hours_settings) return;
        const data = this.state.workHoursRulesBasedOnDepartments[index];
        const id = data.id;
        if (!id) return;
        this.setState({ loading: true }, () => this.loadWorkHoursRulesById(id));
    }

    handleChange = (name, value) => {
        const { workPlanSettings } = this.state;
        workPlanSettings[name] = value;
        if (name === 'allow_work_hours_settings' && !value) {
            workPlanSettings.allow_union_approval = false;
            workPlanSettings.allow_strict_mode = false;
            workPlanSettings.allow_resource_planner = false;
        }
        this.props.handleUserDataChange('workPlanSettings', workPlanSettings);
        this.setState({ workPlanSettings });
    }

    loadWorkHoursRulesById = async (id) => {
        try {
            const result = await this.props.clientStore.getWorkHoursRuleById(id);
            this.toggleModal(true, result.workHoursRule);
        } catch (err) {
            this.setState({ loading: false });
            console.error(err);
        }
    }

    toggleModal = (value, data) => {
        this.setState({ isEdit: value, editData: data, loading: false });
    }

    getDepartments = () => {
        const { currentEntity } = this.props.clientStore;
        const departments = currentEntity.client.data?.roles || [];
        const transformedDepartments = departments.map(department => ({
            value: department.code,
            label: department.name
        }));

        transformedDepartments.unshift({
            value: 'z_none',
            label: 'Others',
        });

        return transformedDepartments;
    }

    validateEmail = (email) => {
        const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return emailRegex.test(email);
    }

    handleAndValidateEmail = (value) => {
        const emails = value.map(item => item.email.trim()).filter(email => email);
        const { workPlanSettings } = this.state;
        workPlanSettings['union_emails'] = emails;
        this.props.handleUserDataChange('workPlanSettings', workPlanSettings);
        this.setState({ workPlanSettings });
    }

    render() {
        const { t } = this.props;
        const { currentEntity } = this.props.clientStore;
        const { dateTimeRules } = currentEntity.client.data;
        const { loading, workPlanSettings, workHoursRulesBasedOnDepartments, isEdit, editData, showEmailModal } = this.state;
        const {
            allow_work_hours_settings, allow_union_approval, allow_strict_mode, union_emails,
            lockInPeriodForUnionApproval, lockInPeriodForPublish, lockInPeriodEditPublishedShift, allow_resource_planner, allow_optional_roster_shift_override
        } = workPlanSettings;
        const formattedRules = workHoursRulesBasedOnDepartments.map(rule => {
            const departments = this.getDepartments();
            const department = departments.find(r => r.value === rule.department);
            return {
                ...rule,
                departmentName: department ? department.label : rule.department
            };
        });

        if (loading) return <LoadingSpinner />

        return (
            <>
                <Row className='mb-3'>
                    <label className="control-label font-size-15 font-color-primary">{t('Basic')}</label>
                </Row>
                <Row className='my-3 mb-1'>
                    <Col sm={12} className='d-flex align-items-center'>
                        <Row className='w-100'>
                            <Col xs={1}>
                                <SwitchWidget
                                    value={allow_work_hours_settings}
                                    onChange={checked => this.handleChange('allow_work_hours_settings', checked)}
                                />
                            </Col>
                            <Col xs={5} className='d-flex'>
                                <label className="control-label">{t('Allow Roster')}</label>
                                <div className='ml-30'>
                                    <OverlayTrigger
                                        key="allow_work_hours_settings"
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("If Enabled this feature will provide you access to Roster management and create the rules of work hours based on each Department.")}
                                            </Tooltip>
                                        }>
                                        <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col sm={12} className={`d-flex align-items-center ${allow_work_hours_settings ? '' : 'disabled-opacity'}`}>
                        <Row className='w-100'>
                            <Col xs={1}>
                                <SwitchWidget
                                    value={allow_union_approval}
                                    onChange={checked => this.handleChange('allow_union_approval', checked)}    
                                    disabled={!allow_work_hours_settings}
                                />
                            </Col>
                            <Col xs={5} className='d-flex'>
                                <label className="control-label">{t('Allow Union Approval')}</label>
                                <div className='ml-30'>
                                    <OverlayTrigger
                                        key="allow_work_hours_settings"
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("If Enabled, Union approval needed to approve the roster templates")}
                                            </Tooltip>
                                        }>
                                        <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </div>
                            </Col>
                            <Col xs={1}>
                                <SwitchWidget
                                    value={allow_strict_mode}
                                    onChange={checked => this.handleChange('allow_strict_mode', checked)}
                                    disabled={!allow_work_hours_settings}
                                />
                            </Col>
                            <Col xs={5} className='d-flex'>
                                <label className="control-label">{t('Allow Strict Mode')}</label>
                                <div className='ml-30'>
                                    <OverlayTrigger
                                        key="allow_strict_mode"
                                        placement="left"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("If Enabled this feature will restrict the Admin/Manager from publishing the shifts if rules are not met")}.
                                            </Tooltip>
                                        }>
                                        <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {allow_union_approval && (
                    <>
                        <Row className='mb-1'>
                            <Col md={6} >
                                <label className="control-label">{t('Union Emails')}</label>
                                <input
                                    className={'form-control'}
                                    type="text"
                                    value={union_emails.join(', ')}
                                    placeholder={t('Union Emails')}
                                    onClick={() => this.setState({ showEmailModal: true })}
                                />
                            </Col>
                            <Col md={6}>
                                <label className="control-label">{t('Minimum Lock in period before union Approval (in Days)')}</label>
                                <NumberInput
                                    type="number"
                                    min={4}
                                    placeholder={t('for example: 28')}
                                    value={lockInPeriodForUnionApproval}
                                    onChange={e => this.handleChange('lockInPeriodForUnionApproval', e.target.value)}
                                />
                            </Col>
                        </Row>
                    </>
                )}
                <Row className={`mb-1 ${allow_work_hours_settings ? '' : 'disabled-opacity'}`}>
                    <Col md={6}>
                        <label className="control-label">{t('Minimum Lock in period before Publishing (in Days)')}</label>
                        <NumberInput
                            type="number"
                            min={2}
                            placeholder={t('for example: 14')}
                            value={lockInPeriodForPublish}
                            onChange={e => this.handleChange('lockInPeriodForPublish', e.target.value)}
                            disabled={!allow_work_hours_settings}
                        />
                    </Col>
                    <Col md={6}>
                        <label className="control-label">{t('Minimum Lock in period for edit published shift (in Days)')}</label>
                        <NumberInput
                            type="number"
                            min={2}
                            value={lockInPeriodEditPublishedShift}
                            onChange={e => this.handleChange('lockInPeriodEditPublishedShift', e.target.value)}
                            disabled={!allow_work_hours_settings}
                        />
                    </Col>
                </Row>
                <hr />
                <Row className={`mb-3 my-3 mb-1 ${allow_work_hours_settings ? '' : 'disabled-opacity'}`}>
                    <label className="mb-3 control-label font-size-15 font-color-primary">{t('Resource Planner Settings')}</label>
                    <Col sm={12} className='d-flex align-items-center'>
                        <Row className='w-100'>
                            <Col xs={1}>
                                <SwitchWidget
                                    value={allow_resource_planner}
                                    onChange={checked => this.handleChange('allow_resource_planner', checked)}
                                    disabled={!allow_work_hours_settings}
                                />
                            </Col>
                            <Col xs={11} className='d-flex'>
                                <label className="control-label">{t('Allow Resource Planner')}</label>
                                <div className='ml-30'>
                                    <OverlayTrigger
                                        key="allow_resource_planner_settings"
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("If Enabled, this feature will provide you access to plan resources based on required skills and groups to maximize the efficiency of your workforce.")}
                                            </Tooltip>
                                        }>
                                        <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <hr />
                <Row className={`mb-3 my-3 mb-1 ${allow_work_hours_settings ? '' : 'disabled-opacity'}`}>
                    <label className="mb-3 control-label font-size-15 font-color-primary">{t('Roster Shift Publishing')}</label>
                    <Col sm={12} className='d-flex align-items-center'>
                        <Row className='w-100'>
                            <Col xs={1}>
                                <SwitchWidget
                                    value={allow_optional_roster_shift_override}
                                    onChange={checked => this.handleChange('allow_optional_roster_shift_override', checked)}
                                    disabled={!allow_work_hours_settings}
                                />
                            </Col>
                            <Col xs={11} className='d-flex'>
                                <label className="control-label">{t('Allow optional roster shift override')}</label>
                                <div className='ml-30'>
                                    <OverlayTrigger
                                        key="allow_optional_roster_shift_override"
                                        placement="right"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("If Enabled, publishing shifts from a roster shows options to control whether existing shifts and their auto time recording are overridden.")}
                                            </Tooltip>
                                        }>
                                        <i className="fa fa-info-circle text-muted" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <hr />
                <Row className={`mt-1 align-items-center ${allow_work_hours_settings ? '' : 'disabled-opacity'}`}>
                    <Col xs={8}>
                        <label className="control-label font-size-15 font-color-primary">{t('Work Plan setup')}</label>
                    </Col>
                    <Col xs={4} className='d-flex justify-content-end'>
                        <Button wd fill onClick={() => this.toggleModal(true, {})} disabled={!allow_work_hours_settings}>
                            <i className="fa fa-plus-circle fa-xl margin-right-10" /> {this.props.t('Add new')}
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <div className={`custom-card ${allow_work_hours_settings ? '' : 'disabled-opacity'}`}>
                        <TableWidget
                            headers={['Label', 'Departments']}
                            metaData={[
                                { field: 'name', type: 'text', placeholder: 'Label', required: true, unique: true },
                                { field: 'departmentName', type: 'text', placeholder: 'Department', required: true, unique: true }
                            ]}
                            data={formattedRules}
                            onChange={_ => { }}
                            customDeleteHandler={(idx) => this.handleDataDelete(idx)}
                            customFormHandler={(idx) => this.editRule(idx)}
                            minRemoveIndex={!allow_work_hours_settings && formattedRules.length}
                        />
                    </div>
                </Row>
                <Modal
                    className={"modal right fade modal_revised"}
                    backdrop="static"
                    show={isEdit}
                    onHide={() => this.toggleModal(false, {})}
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{t('Work hours Rules')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close_button'
                            onClick={() => this.toggleModal(false, {})}
                        />
                    </Modal.Header>
                    <Modal.Body className='position-relative'>
                        <WorkHoursRulesForm
                            val={editData}
                            updateData={this.updateData}
                            edit={isEdit}
                            cancel={() => this.toggleModal(false, {})}
                            handleUserDataChange={this.props.handleUserDataChange}
                            t={this.props.t}
                            dateTimeRules={dateTimeRules}
                        />
                    </Modal.Body>
                </Modal>
                <Modal
                    className={"modal"}
                    show={showEmailModal}
                    onHide={() => this.setState({ showEmailModal: false })}
                >
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{t('Union Emails')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            alt='close_button'
                            onClick={() => this.setState({ showEmailModal: false })}
                        />
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <TableWidget
                                headers={['Email']}
                                metaData={[{ field: 'email', type: 'text', placeholder: 'Email', required: true, unique: true, validate: true }]}
                                data={union_emails.map(email => ({ email }))}
                                onChange={value => this.handleAndValidateEmail(value)}
                                customValidatorHandler={(value) => this.validateEmail(value)}
                                customDeleteHandler={(idx) => {
                                    const updatedEmails = [...union_emails];
                                    updatedEmails.splice(idx, 1);
                                    this.setState({ union_emails: updatedEmails });
                                }}
                            />
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}
export default inject('clientStore', 'commonStore')(withLocalization(withRemoveDialog(observer(AverageWorkHoursRules))));
